import { Typography } from "@mui/material";

import { usePreviewCourse } from "../../hooks/usePreviewCourse";
import { CourseLesson } from "./CourseLesson";
import { USDFormatter } from "../../../../../../utils";

export function CourseLessons() {
	const { course } = usePreviewCourse();

	if (!course) {
		return null;
	}

	const price = course.lesson.reduce(
		(acc, cur) => (cur.totalCost ?? 0) + acc,
		0,
	);

	return (
		<div className="course-lessons-container">
			<Typography className="big-text black-label">Classes</Typography>

			{course.lesson.map((lesson) => {
				return <CourseLesson lesson={lesson} key={lesson.id} />;
			})}

			<div className="separator" />

			<Typography className="title-text bold price-text">
				{USDFormatter.format(price)}
			</Typography>
		</div>
	);
}
